import { RootState } from "../../rootReducer";

export const selectIsLoadingFullStressNoti = (state: RootState) =>
  state.sendFullStressNotification.loading;
export const selectIsSavedFullStressNoti = (state: RootState) =>
  state.sendFullStressNotification.saved;
export const selectFullStressNotiErrorMessage = (state: RootState) =>
  state.sendFullStressNotification.error;
export const sendFullStressNotificationDataResponse = (state: RootState) =>
  state.sendFullStressNotification.sendFullStressNotificationResponse;
